/* Auto-generated by Arlo Admin — Labels settings. Do not edit manually. */
window.ArloLabelConfig = {
  "labelTypes": {
    "rect": {
      "label": "Rectangle 45×24mm",
      "wMm": 45,
      "hMm": 24
    },
    "circle": {
      "label": "Large Round ⌀40mm",
      "wMm": 40,
      "hMm": 40
    },
    "pencil": {
      "label": "Pencil 45×10mm",
      "wMm": 45,
      "hMm": 10
    },
    "mini": {
      "label": "Mini 45×10mm",
      "wMm": 45,
      "hMm": 10
    },
    "bagtag": {
      "label": "Bag Tag 68×90mm",
      "wMm": 68,
      "hMm": 90
    }
  },
  "fonts": [
    {
      "family": "arlo-textacaps",
      "label": "Texta Caps",
      "yOffsetPx": -1,
      "scalePct": 122,
      "lineSpacePct": 110,
      "builtin": false,
      "files": [
        {
          "format": "woff",
          "url": "https://cdn.shopify.com/s/files/1/0820/7071/files/Font-FrenchFriesILTD-Regular.woff"
        }
      ]
    },
    {
      "family": "arlo-arloplayground",
      "label": "Freehand",
      "yOffsetPx": 4,
      "scalePct": 200,
      "lineSpacePct": 70,
      "builtin": false,
      "files": [
        {
          "format": "truetype",
          "url": "https://cdn.shopify.com/s/files/1/0820/7071/files/Font-ArloPlayGroundWEB.ttf"
        }
      ]
    },
    {
      "family": "arlo-moonflower",
      "label": "All Caps",
      "yOffsetPx": 5,
      "scalePct": 130,
      "lineSpacePct": 100,
      "builtin": false,
      "files": [
        {
          "format": "woff",
          "url": "https://cdn.shopify.com/s/files/1/0820/7071/files/Font-Moon_Flower_Bold.woff"
        },
        {
          "format": "truetype",
          "url": "https://cdn.shopify.com/s/files/1/0820/7071/files/Font-Moon_Flower_Bold.ttf"
        }
      ]
    },
    {
      "family": "Vic Modern Cursive",
      "label": "Primary School",
      "yOffsetPx": 5,
      "scalePct": 100,
      "lineSpacePct": 140,
      "builtin": true,
      "files": []
    }
  ],
  "maxChars": 12,
  "longNameWarnAt": 9,
  "colours": [
    {
      "name": "Charcoal",
      "hex": "#454545"
    },
    {
      "name": "Lilac",
      "hex": "#6979ad"
    },
    {
      "name": "Dark Denim",
      "hex": "#4f758b"
    },
    {
      "name": "Pink",
      "hex": "#ee9ba7"
    },
    {
      "name": "Dusty Blue",
      "hex": "#84a6b6"
    },
    {
      "name": "Mustard",
      "hex": "#f2b981"
    },
    {
      "name": "Rust",
      "hex": "#b45e41"
    }
  ],
  "packs": [
    {
      "name": "Starter",
      "price": 18,
      "badge": "",
      "description": "36 waterproof stick-on labels",
      "contents": [
        {
          "type": "rect",
          "qty": 24,
          "note": "Stick-On",
          "output": "main",
          "displayName": ""
        },
        {
          "type": "pencil",
          "qty": 32,
          "note": "Stick-On",
          "output": "main",
          "displayName": ""
        }
      ]
    },
    {
      "name": "Value Pack",
      "price": 34,
      "badge": "Best Value",
      "description": "108 stick-on labels (mixed sizes)",
      "contents": [
        {
          "type": "rect",
          "qty": 28,
          "note": "Stick-On",
          "output": "main",
          "displayName": ""
        },
        {
          "type": "circle",
          "qty": 20,
          "note": "Stick-On",
          "output": "main",
          "displayName": ""
        },
        {
          "type": "pencil",
          "qty": 60,
          "note": "Stick-On",
          "output": "main",
          "displayName": ""
        }
      ]
    }
  ],
  "sheet": {
    "pageWMm": 210,
    "pageHMm": 140,
    "marginMm": 1,
    "gapMm": 2,
    "dpi": 300,
    "cutColour": "#ff00ff",
    "cutSpotName": "CutContour",
    "cutLayer": "above",
    "cutLines": true,
    "autoRotate": true,
    "pageBg": true,
    "bleedMm": 1
  },
  "linkedProducts": {
    "ironVariantId": "45370138984630",
    "bagtagVariantId": "45371163967670",
    "bagtagUpsellVariantId": "45371190608054",
    "ironUpsellVariantId": "45371205386422"
  },
  "bagtag": {
    "namePosPct": 18,
    "nameScalePct": 100,
    "bgZoomPct": 200,
    "fonts": [
      {
        "scalePct": 100,
        "posOffsetPct": -6.5
      },
      {
        "scalePct": 120,
        "posOffsetPct": 0
      },
      {
        "scalePct": 120,
        "posOffsetPct": -4.5
      },
      {
        "scalePct": 100,
        "posOffsetPct": -4
      }
    ],
    "backgrounds": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0820/7071/files/proof-overlay-1788404462675.png?v=1788404465",
        "name": "Skateboards",
        "textColor": "white",
        "productHandles": [
          "test-label-product"
        ]
      }
    ]
  },
  "scenes": {
    "rect": {
      "enabled": false,
      "bg": "",
      "bgName": "",
      "bgAsset": "",
      "fg": "",
      "fgName": "",
      "fgAsset": "",
      "placement": {
        "centreXPct": 50,
        "centreYPct": 50,
        "widthPct": 40,
        "rotationDeg": 0
      }
    },
    "circle": {
      "enabled": false,
      "bg": "",
      "bgName": "",
      "bgAsset": "",
      "fg": "",
      "fgName": "",
      "fgAsset": "",
      "placement": {
        "centreXPct": 50,
        "centreYPct": 50,
        "widthPct": 40,
        "rotationDeg": 0
      }
    },
    "pencil": {
      "enabled": false,
      "bg": "",
      "bgName": "",
      "bgAsset": "",
      "fg": "",
      "fgName": "",
      "fgAsset": "",
      "placement": {
        "centreXPct": 50,
        "centreYPct": 50,
        "widthPct": 40,
        "rotationDeg": 0
      }
    },
    "mini": {
      "enabled": false,
      "bg": "",
      "bgName": "",
      "bgAsset": "",
      "fg": "",
      "fgName": "",
      "fgAsset": "",
      "placement": {
        "centreXPct": 50,
        "centreYPct": 50,
        "widthPct": 40,
        "rotationDeg": 0
      }
    },
    "bagtag": {
      "enabled": false,
      "bg": "",
      "bgName": "",
      "bgAsset": "",
      "fg": "",
      "fgName": "",
      "fgAsset": "",
      "placement": {
        "centreXPct": 50,
        "centreYPct": 50,
        "widthPct": 40,
        "rotationDeg": 0
      }
    }
  },
  "upsells": [
    {
      "id": "bagtag",
      "kind": "bagtag",
      "enabled": true,
      "title": "Add a matching bag tag",
      "description": "Same design and name — perfect for school bags and drink bottles.",
      "fullPrice": 23,
      "discountedPrice": 15,
      "badge": "Save $8",
      "variantId": "45371190608054"
    },
    {
      "id": "ironon",
      "kind": "sheet",
      "mirror": true,
      "enabled": true,
      "title": "Add iron-on clothing labels",
      "description": "36 labels for uniforms, socks and hats — same design and name.",
      "fullPrice": 25,
      "discountedPrice": 18.75,
      "badge": "Save 25%",
      "variantId": "45371205386422",
      "contents": [
        {
          "type": "rect",
          "qty": 18,
          "note": "Iron-On",
          "displayName": "Iron-On Rectangles"
        },
        {
          "type": "mini",
          "qty": 18,
          "note": "Iron-On",
          "displayName": "Iron-On Name Tapes"
        }
      ]
    }
  ],
  "standaloneProducts": {
    "iron-on-clothing-labels": {
      "kind": "sheet",
      "mirror": true,
      "previewShapes": [
        "rect",
        "pencil"
      ],
      "contents": [
        {
          "type": "rect",
          "qty": 18,
          "note": "Iron-On",
          "displayName": "Iron-On Rectangles"
        },
        {
          "type": "mini",
          "qty": 18,
          "note": "Iron-On",
          "displayName": "Iron-On Name Tapes"
        }
      ],
      "blurb": "36 iron-on labels — 18 rectangles + 18 name tapes"
    },
    "acrylic-bag-tag": {
      "kind": "bagtag",
      "previewShapes": [
        "bagtag"
      ],
      "contents": [],
      "blurb": "Personalised acrylic bag tag — 68 × 90 mm"
    }
  },
  "builderProfiles": {
    "ironon-36": {
      "label": "Iron-On — 36 labels",
      "kind": "sheet",
      "mirror": true,
      "previewShapes": [
        "rect",
        "pencil"
      ],
      "contents": [
        {
          "type": "rect",
          "qty": 18,
          "note": "Iron-On",
          "displayName": "Iron-On Rectangles"
        },
        {
          "type": "mini",
          "qty": 18,
          "note": "Iron-On",
          "displayName": "Iron-On Name Tapes"
        }
      ],
      "blurb": "36 iron-on labels — 18 rectangles + 18 name tapes"
    },
    "ironon-72": {
      "label": "Iron-On — 72 labels",
      "kind": "sheet",
      "mirror": true,
      "previewShapes": [
        "rect",
        "pencil"
      ],
      "contents": [
        {
          "type": "rect",
          "qty": 36,
          "note": "Iron-On",
          "displayName": "Iron-On Rectangles"
        },
        {
          "type": "mini",
          "qty": 36,
          "note": "Iron-On",
          "displayName": "Iron-On Name Tapes"
        }
      ],
      "blurb": "72 iron-on labels — 36 rectangles + 36 name tapes"
    },
    "ironon-tapes": {
      "label": "Iron-On — name tapes only",
      "kind": "sheet",
      "mirror": true,
      "previewShapes": [
        "pencil"
      ],
      "contents": [
        {
          "type": "mini",
          "qty": 36,
          "note": "Iron-On",
          "displayName": "Iron-On Name Tapes"
        }
      ],
      "blurb": "36 iron-on name tapes"
    },
    "bagtag": {
      "label": "Bag Tag",
      "kind": "bagtag",
      "previewShapes": [
        "bagtag"
      ],
      "contents": [],
      "blurb": "Personalised acrylic bag tag — 68 × 90 mm"
    }
  },
  "classicDesigns": [],
  "uploadcarePublicKey": "58028aeb7a09a9604d9a"
};
